export const MESSAGE_TEACHER_POLL_INTERVAL_MS = 60_000;
